import React, { useEffect, useRef, useState } from 'react';
import { STooltip, STooltipFloating } from './styled';
import { Button } from '../Button';
import { Icon } from '../Icon';
import { Text } from '../Text';

type TooltipProps = {
  text: string;
};

export const Tooltip = ({ text }: TooltipProps) => {
  const [isActive, setIsActive] = useState<boolean>(false);
  const refDiv = useRef<HTMLDivElement | null>(null);

  useEffect(() => {
    window.addEventListener('resize', () => {
      setIsActive(false);
    });

    window.addEventListener('click', (ev) => {
      if (ev.target instanceof Element && refDiv.current) {
        if (!refDiv.current.contains(ev.target)) setIsActive(false);
      }
    });
  }, [refDiv]);

  return (
    <STooltip ref={refDiv}>
      <Button
        size="small"
        isIcon
        variant="tertiary"
        isActive={isActive}
        onClick={() => setIsActive(!isActive)}
      >
        <Icon name="infoCircle" />
      </Button>
      <STooltipFloating data-active={isActive}>
        <Text text={text} />
        <Button
          size="small"
          isIcon
          variant="tooltip"
          onClick={() => setIsActive(false)}
        >
          <Icon name="closeCircle" />
        </Button>
      </STooltipFloating>
    </STooltip>
  );
};
